import { CONTACT_DEFAULT_AVATAR } from '../constants/images';
import type { TContactFormValues } from './types';

export function buildUpdateContactBody(
    values: TContactFormValues
): Record<string, unknown> {
    const body: Record<string, unknown> = {
        name: values.name.trim(),
        store: values.store,
        countryCode: values.countryCode,
        secondaryCountryCode: values.secondaryCountryCode,
    };

    if (values.email.trim()) body.email = values.email.trim();
    if (values.phone.trim()) body.phone = values.phone.trim();
    if (values.secondaryPhone.trim()) {
        body.secondaryPhone = values.secondaryPhone.trim();
    }
    body.employment = values.employment.trim();
    body.notes = values.notes.trim();
    if (values.users?.length) {
        body.users = values.users.map((userRef) => userRef.value);
    }
    body.tags = values.tags;
    body.image = values.image || CONTACT_DEFAULT_AVATAR;

    return body;
}
